import ClipLoader from 'react-spinners/ClipLoader';
import styled from 'styled-components';
import { colors } from '../../../../styles/colors';
import { space } from '../../../../styles/onboardingUiTokens';

export type LoadingSpinnerProps = {
  color?: string;
  className?: string;
  size?: number;
};

export function LoadingSpinner(props: LoadingSpinnerProps) {
  return (
    <Container className={props.className}>
      <ClipLoader
        color={props.color ?? colors.white}
        loading={true}
        size={props.size ?? 24}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${space.xxxs};
`;
